import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import Seo from "../components/seo"
import Card from "../components/card"
import PageTitle from "../components/pageTitle"
import Container from "../components/container"
import Sidebar from "../components/sidebar"
import Pagination from "../components/pagination"

const RecentPostsTemplate = ({ pageContext, data, location }) => {
  const posts = data.allMarkdownRemark.nodes

  return (
    <Layout location={location}>
      <Seo
        title={`${
          pageContext.currentPage !== 1 ?
          `${pageContext.currentPage}ページ目｜` : ``
        }最新記事一覧`}
        description={`DX BLOGの最新記事一覧${
          pageContext.currentPage !== 1 ?
          `の${pageContext.currentPage}ページ目` : ``}です。CDP・データ活用・アドテク・広告などに関連する情報を紹介しています。`}
      />
      <PageTitle title={`最新記事`} />
      <Container className="lg:flex justify-between mt-6 lg:mt-12 mb-6 lg:mb-12">
        <div className="lg:w-2/3">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 lg:gap-7">
            {posts.map(post => (
              <Card post={post} size="m" key={`recent-${post.id}`} />
            ))}
          </div>
          <div className="pt-14">
            <Pagination
              numPages={pageContext.numPages}
              currentPage={pageContext.currentPage}
              pageLimit={5}
              pagingPath={`/`}
            />
          </div>
        </div>
        <div className="lg:w-1/4">
          <Sidebar></Sidebar>
        </div>
      </Container>
    </Layout>
  )
}

export default RecentPostsTemplate

export const pageQuery = graphql`
  query recentPostsQuery($skip: Int!, $limit: Int!) {
    allMarkdownRemark(
      limit: $limit
      sort: { fields: [frontmatter___date], order: DESC }
      skip: $skip
      filter: { fields: { meta: { draft: { eq: false } } } }
    ) {
      totalCount
      nodes {
        fields {
          meta {
            slug
          }
        }
        frontmatter {
          date(formatString: "YYYY.MM.DD")
          title
          description
          tags
          cover {
            childImageSharp {
              gatsbyImageData(width: 800, formats: AUTO)
            }
          }
        }
        id
      }
    }
  }
`
